import { ValidationRule } from "react-hook-form";

export const filePathValidationRulePattern: ValidationRule<RegExp> = {
    message: "Path isn't correct, has to start with '/' or '\\' or '[A-Z]:/' or '[A-Z]:\\' or '[a-z]:/' or '[a-z]:\\'",
    value: /^(?![a-zA-Z]:[^\\/])(?:[a-zA-Z]:|(?:\\|\/))[^\\/:*?"<>|\r\n]*(?:\\|\/)?(?:[^\\/:*?"<>|\r\n]+(?:\\|\/))*[^\\/:*?"<>|\r\n]*$/
};
